import { TextValue } from '../_general';

export enum AffiliateEnum {
    NONE = 0,
    TRANSNETYX,
    TACONIC,
}

export const affiliateText: { [key in AffiliateEnum]: string } = {
    [AffiliateEnum.NONE]: 'None',
    [AffiliateEnum.TRANSNETYX]: 'Transnetyx',
    [AffiliateEnum.TACONIC]: 'Taconic',
};

export const affiliates: TextValue[] = [
    { text: affiliateText[AffiliateEnum.NONE], value: AffiliateEnum.NONE },
    { text: affiliateText[AffiliateEnum.TRANSNETYX], value: AffiliateEnum.TRANSNETYX },
    { text: affiliateText[AffiliateEnum.TACONIC], value: AffiliateEnum.TACONIC },
];
